import { DOC_LIBRARY_QUERY } from "@/graphql/doc-library-query";
import {
  STATUS,
  User,
  docLibraryData,
  reviewerDataTable,
} from "@/models/common-interface/common.interface";
import router from "@/router/router";
import apolloClient from "@/vue-apollo";
import gql from "graphql-tag";
export class Utils {
  static get instance() {
    return this.INSTANCE;
  }

  private ACCESS_TOKEN = "access_token";
  private USER_DETAILS = "user_details";
  public ANONYMOUS_TOKEN = "anonymousToken";
  public PROFILE_DETAIL = "profileData";
  public TRANING_PAYLOAD = "trainingFormPayload";
  public TRAINING_INDEX = "trainingFormFilledIndex";
  public CERTIFICATION_PAYLOAD = "certificationFormPayload";
  public CERTIFICATION_INDEX = "certificationFormFilledIndex";
  public RENEWAL_PAYLOAD = "renewalPayLoadData";
  public RENEWAL_INDEX = "renewalFormFilledIndex";
  public ADMIN_ACCESS_TOKEN = "admin_access_token";
  public ADMIN_USER_DETAIL = "admin_user_details";
  public IMPERSONATE_ID = "impersonateId";
  public emptyValues = [undefined, null, "", {}];

  public checkIsMobileView() {
    if (typeof window === "undefined") {
      return false;
    }
    return window.innerWidth < 567;
  }
  public checkIsTabView() {
    if (typeof window === "undefined") {
      return false;
    }
    return window.innerWidth < 1024;
  }

  public checkIsDesktopView() {
    if (typeof window === "undefined") {
      return true;
    }
    return window.innerWidth > 1024;
  }

  public checkIsIpadView() {
    if (typeof window === "undefined") {
      return false;
    }
    return window.innerWidth > 991 && window.innerWidth < 1200;
  }

  public addition(data: number[]) {
    return data.reduce((a, b) => {
      return a + b;
    }, 0);
  }

  public onlyNumberKey(evt: any, length?: number) {
    const keysAllowed: string[] = [
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
    ];
    const keyPressed: string = evt.key;
    if (!keysAllowed.includes(keyPressed)) {
      evt.preventDefault();
    } else {
      if (evt.target.value.length === length) {
        evt.preventDefault();
      }
    }
  }

  public onlyAlphabets(evt: any, fieldName = "") {
    let regex: RegExp;
    if (fieldName === "state" || fieldName === "currentState") {
      regex = /^[A-Z]*$/;
    } else {
      regex = /^[a-zA-Z]*$/;
    }
    const keyPressed: string = evt.key;

    if (!regex.test(keyPressed)) {
      evt.preventDefault();
    }
  }

  public telCharacterValidate(evt: any, length?: number) {
    const keysAllowed: string[] = [
      "-",
      "(",
      ")",
      " ",
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
    ];
    const keyPressed: string = evt.key;
    if (!keysAllowed.includes(keyPressed)) {
      evt.preventDefault();
    } else {
      if (evt.target.value.length === length) {
        evt.preventDefault();
      }
    }
  }

  public avoidNumbersAndSpecialCharacters(e: any) {
    const char = "~`!@#$%^&*()+=-_[]\\';,./{}|\":<>?0123456789";
    if (char.includes(e.key)) {
      e.preventDefault();
    }
  }

  customValidator = {
    tagsValidation: {
      getMessage(field: string, maxCount: number[], data: any) {
        return (
          (data && data.message) ||
          `Number of ${field} must be ${maxCount[0]} or less`
        );
      },
      validate(tags: string[], maxCount: number[]) {
        if (tags.length <= maxCount[0]) {
          return true;
        }
        return false;
      },
    },
  };

  public getUserDetails() {
    const userDetails = localStorage.getItem("user_details");
    if (userDetails) {
      return JSON.parse(userDetails);
    }
  }

  public textAreaTagsConversion(value: string) {
    const replaceObj: any = {
      "\\n": "<br />",
      "\\r": "<br />",
    };
    value = value.replace(/\\n|\\r/gi, function (matched) {
      return replaceObj[matched];
    });
    return value;
  }

  public formTypeTableRowClass(item: reviewerDataTable, type: string) {
    if (item && type === "row") {
      if (item.submittedMode === "migration") {
        return "migration";
      } else if (item.submittedMode === "offline") {
        return "offline";
      } else {
        return "";
      }
    }
  }

  public scoringSectionHideShow(
    applicationStatus: string,
    currentUserStatus: string,
    applicationName = "",
    userTaskStatus: string[] = []
  ) {
    const value = {} as any;
    const userDetails: User = utils.getUserDetails();
    if (applicationStatus === STATUS.received) {
      value["showRubricTab"] = false;
    } else if (applicationStatus === STATUS.processing) {
      value["showCommentBox"] = true;
      value["showRubricTab"] = true;
      if (currentUserStatus !== STATUS.inProgress) {
        value["showCommentBoxWithDisable"] = true;
      }
    } else if (applicationStatus === STATUS.accepted) {
      value["showRubricTab"] = true;
      applicationName === "certification"
        ? (value["showCertification"] = true)
        : (value["showCommentBoxWithDisable"] = true);
    } else if (applicationStatus === STATUS.notAccepted) {
      if (
        currentUserStatus === STATUS.notAccepted &&
        !userDetails.roles.includes("REVIEW_CERTIFICATE")
      ) {
        value["showCommentBoxWithDisable"] = true;
        value["showRubricTab"] = true;
      } else {
        if (userTaskStatus.includes(STATUS.processing)) {
          value["showCommentBoxWithDisable"] = true;
          value["showRubricTab"] = true;
        } else {
          value["showRubricTab"] = false;
        }
      }
    } else if (applicationStatus === STATUS.needMoreInfo) {
      if (
        currentUserStatus === STATUS.needMoreInfo &&
        userDetails.roles.includes("REVIEW_CERTIFICATE") &&
        !userTaskStatus.includes(STATUS.processing)
      ) {
        value["showRubricTab"] = false;
      } else {
        if (
          userTaskStatus.includes(STATUS.processing) &&
          currentUserStatus !== STATUS.needMoreInfo
        ) {
          value["showCommentBoxWithDisable"] = true;
          value["showRubricTab"] = true;
        } else {
          value["showCommentBox"] = true;
          value["showRubricTab"] = true;
        }
      }
    } else if (applicationStatus === STATUS.waitingForTraining) {
      if (
        currentUserStatus === STATUS.waitingForTraining &&
        userDetails.roles.includes("REVIEW_CERTIFICATE") &&
        !userTaskStatus.includes(STATUS.processing)
      ) {
        value["showRubricTab"] = false;
      } else {
        if (
          userTaskStatus.includes(STATUS.processing) &&
          currentUserStatus !== STATUS.waitingForTraining
        ) {
          value["showCommentBoxWithDisable"] = true;
          value["showRubricTab"] = true;
        } else {
          value["showCommentBox"] = true;
          value["showRubricTab"] = true;
        }
      }
    } else if (applicationStatus === STATUS.completedTraining) {
      if (
        currentUserStatus === STATUS.completedTraining &&
        userDetails.roles.includes("REVIEW_CERTIFICATE") &&
        !userTaskStatus.includes(STATUS.processing)
      ) {
        value["showRubricTab"] = false;
      } else {
        if (
          userTaskStatus.includes(STATUS.processing) &&
          currentUserStatus !== STATUS.completedTraining
        ) {
          value["showCommentBoxWithDisable"] = true;
          value["showRubricTab"] = true;
        } else {
          value["showCommentBox"] = true;
          value["showRubricTab"] = true;
        }
      }
    }
    return value;
  }

  public deleteLocalStorage() {
    localStorage.removeItem(this.ACCESS_TOKEN);
    localStorage.removeItem(this.USER_DETAILS);
    localStorage.removeItem(this.ANONYMOUS_TOKEN);
    if (localStorage.getItem("profileData")) {
      localStorage.removeItem(this.PROFILE_DETAIL);
    }
    if (localStorage.getItem(this.TRANING_PAYLOAD)) {
      localStorage.removeItem(this.TRANING_PAYLOAD);
      localStorage.removeItem(this.TRANING_PAYLOAD);
    }
    if (localStorage.getItem(this.CERTIFICATION_PAYLOAD)) {
      localStorage.removeItem(this.CERTIFICATION_PAYLOAD);
      localStorage.removeItem(this.CERTIFICATION_INDEX);
    }
    if (localStorage.getItem(this.RENEWAL_PAYLOAD)) {
      localStorage.removeItem(this.RENEWAL_PAYLOAD);
      localStorage.removeItem(this.RENEWAL_INDEX);
    }
    if (localStorage.getItem(this.ADMIN_ACCESS_TOKEN)) {
      localStorage.removeItem(this.ADMIN_ACCESS_TOKEN);
    }
    if (localStorage.getItem(this.ADMIN_USER_DETAIL)) {
      localStorage.removeItem(this.ADMIN_USER_DETAIL);
    }
    if (localStorage.getItem(this.IMPERSONATE_ID)) {
      localStorage.removeItem(this.IMPERSONATE_ID);
    }
  }

  public addressBuilder(
    previewData: any,
    formName: string,
    addressType: string,
    isMultipleSupervisor = false,
    idx = 0
  ) {
    let buildedAddress = "";
    const defaultAddress = [
      "addressLine1",
      "addressLine2",
      "city",
      "state",
      "zip",
    ];
    const supervisorAddress = [
      "supervisorAddressLine1",
      "supervisorAddressLine2",
      "supervisorCity",
      "supervisorState",
      "supervisorZip",
    ];
    if (previewData && previewData[formName]) {
      if (addressType === "default") {
        defaultAddress.map((field) => {
          if (previewData[formName][field]) {
            buildedAddress = `${previewData[formName].addressLine1}\n\n${
              !utils.emptyValues.includes(previewData[formName].addressLine2)
                ? previewData[formName].addressLine2 + "\n\n"
                : ""
            }${previewData[formName].city}  |  ${
              previewData[formName].state
            }  |  ${previewData[formName].zip}`;
          }
        });
        return buildedAddress;
      } else if (addressType === "supervisor") {
        supervisorAddress.map((field) => {
          if (isMultipleSupervisor === true) {
            if (previewData[formName][idx][field]) {
              buildedAddress = `${
                previewData[formName][idx].supervisorAddressLine1
              }\n\n${
                !utils.emptyValues.includes(
                  previewData[formName][idx].supervisorAddressLine2
                )
                  ? previewData[formName][idx].supervisorAddressLine2 + "\n\n"
                  : ""
              }${previewData[formName][idx].supervisorCity}  |  ${
                previewData[formName][idx].supervisorState
              }  |  ${previewData[formName][idx].supervisorZip}`;
            }
          } else {
            if (previewData[formName][field]) {
              buildedAddress = `${
                previewData[formName].supervisorAddressLine1
              }\n\n${
                !utils.emptyValues.includes(
                  previewData[formName].supervisorAddressLine2
                )
                  ? previewData[formName].supervisorAddressLine2 + "\n\n"
                  : ""
              }${previewData[formName].supervisorCity}  |  ${
                previewData[formName].supervisorState
              }  |  ${previewData[formName].supervisorZip}`;
            }
          }
        });
        return buildedAddress;
      }
    }
  }

  public rightMoveTab(content: any, movingWidthSize: number) {
    if (content) {
      content.scrollLeft += movingWidthSize;
      if (content.scrollWidth - content.clientWidth === content.scrollLeft) {
        return {
          leftArrowDisable: false,
          rightArrowDisable: true,
        };
      } else {
        return {
          leftArrowDisable: false,
          rightArrowDisable: false,
        };
      }
    }
  }

  public leftMoveTab(content: any, movingWidthSize: number) {
    if (content) {
      content.scrollLeft -= movingWidthSize;
      if (content.scrollLeft === 0) {
        return {
          leftArrowDisable: true,
          rightArrowDisable: false,
        };
      } else {
        return {
          leftArrowDisable: false,
          rightArrowDisable: false,
        };
      }
    }
  }

  public async getAllDoc() {
    let value: docLibraryData[] = [];
    await apolloClient
      .query({
        query: gql`query ${DOC_LIBRARY_QUERY}`,
      })
      .then((result) => {
        value = result.data.docsLibraries.data;
      });
    return value;
  }

  public filterDoc(data: docLibraryData[], keyName: string) {
    let value: docLibraryData = {} as docLibraryData;
    data.find((doc: docLibraryData) => {
      if (doc.attributes.docKeyName === keyName) {
        value = doc;
      }
    });
    return value?.attributes?.document.data.attributes;
  }

  public errorMessage(error: any, isNavigatetoHome = false): string {
    let message = "";
    switch (error.response.status) {
      case 401:
        message = "Session was expired";
        router.push("/");
        break;
      case 404:
        message = error.response.data.message;
        break;
      case 400:
        message = error.response.data.message;
        break;
      case 409:
        message = error.response.data.message;
        if (isNavigatetoHome) {
          setTimeout(() => {
            router.push("/home");
          }, 3000);
        }
        break;
      case 502:
        message = "Please try again after some time";
        break;
      default:
        message = error.response.data.message;
        break;
    }
    return message;
  }

  public duplicateValueIdx(
    formValues: any,
    formName = "",
    isEmail = false,
    fieldName: string
  ) {
    const duplicateIndexs = [];
    const data = formName ? formValues[formName] : formValues;
    const valueSet = new Set();
    for (let i = 0; i < data.length; i++) {
      const value = isEmail
        ? data[i][fieldName].toLowerCase()
        : data[i][fieldName];
      if (value) {
        if (valueSet.has(value)) {
          duplicateIndexs.push(i);
        } else {
          valueSet.add(value);
        }
      }
    }
    return duplicateIndexs;
  }

  public UIUpdateUsingKey(value: boolean) {
    if (value === true) {
      return false;
    } else {
      return true;
    }
  }

  // Builds the { oldEmail, newEmail } pairs the edit APIs use to move a
  // referral/supervisor row to a new email. The API matches oldEmail exactly,
  // so it is sent as originally saved. A typed email is trimmed in the form
  // data too, so the row and the data JSON end up holding the same value.
  // Untouched rows are left exactly as stored: a pair for them would re-send
  // the request mail to that reference/supervisor.
  public changedEmails(
    formValues: any,
    originalValues: any,
    formName: string,
    fieldName: string
  ) {
    const changed: { oldEmail: string; newEmail: string }[] = [];
    const currentRows = formValues?.[formName] || [];
    const originalRows = originalValues?.[formName] || [];
    currentRows.forEach((row: any, idx: number) => {
      const oldEmail = originalRows[idx]?.[fieldName];
      const typedEmail = row?.[fieldName];
      if (
        !oldEmail ||
        typeof typedEmail !== "string" ||
        typedEmail === oldEmail
      ) {
        return;
      }
      const newEmail = typedEmail.trim();
      if (!newEmail) {
        // Left empty for the required-field validation to report.
        return;
      }
      if (newEmail === oldEmail.trim()) {
        // Only whitespace was added/removed: keep the stored value.
        row[fieldName] = oldEmail;
        return;
      }
      row[fieldName] = newEmail;
      changed.push({ oldEmail, newEmail });
    });
    return changed;
  }

  public statusCaseChange(status: string) {
    const statusWordConvert =
      status === STATUS.notAccepted
        ? "not-accepted"
        : status === STATUS.needMoreInfo
        ? "more-info"
        : status.toLowerCase();

    return statusWordConvert;
  }

  public joinArrObj(data: any[], joinKey: string) {
    let joinName = "";
    joinName = data.map((element) => element[joinKey]).join(", ");
    return joinName;
  }

  public classNameChooser(className: string) {
    let classContainerName = "";
    switch (className) {
      case "common-input":
        classContainerName = "common-input-container";
        break;
      case "input-high":
        classContainerName = "input-high-container";
        break;
      default:
        break;
    }
    return classContainerName;
  }

  public disableField(isEdit: boolean, formType: string) {
    if (!isEdit && formType === "preview") {
      // Applicant Preview
      return true;
    } else {
      return false;
    }
  }

  public disableCommentandScoringSection(
    currentUserStatus: string,
    progressStatus: string,
    section: string
  ) {
    if (
      progressStatus.includes(STATUS.accepted) ||
      progressStatus.includes(STATUS.notAccepted)
    ) {
      return true;
    }
    if (progressStatus.includes(STATUS.processing)) {
      if (
        currentUserStatus.includes(STATUS.inProgress) &&
        section === "comment"
      ) {
        return false;
      } else {
        return true;
      }
    }
    if (progressStatus.includes(STATUS.needMoreInfo)) {
      if (
        currentUserStatus.includes(STATUS.inProgress) &&
        section === "comment"
      ) {
        return false;
      } else if (
        currentUserStatus.includes(STATUS.needMoreInfo) &&
        (section === "scoring" || section === "comment")
      ) {
        return false;
      } else {
        return true;
      }
    }
  }

  public renewalValueSetter(
    renewalData: any,
    renewalFormName: string,
    renewalFieldName: string,
    fetchData: any,
    fetchDataField: string,
    fetchDataFormName = ""
  ) {
    return renewalData[renewalFormName][renewalFieldName]
      ? renewalData[renewalFormName][renewalFieldName]
      : fetchDataFormName
      ? fetchData[fetchDataFormName][fetchDataField]
      : fetchData[fetchDataField];
  }
  public getProfileDetails() {
    const userDetails = localStorage.getItem("profileData");
    if (userDetails) {
      return JSON.parse(userDetails);
    }
  }

  /**
   * Mirrors Constants.EMAIL_PATTERN in cadre-workflow-api. fetchDetailsfromData()
   * runs on every application POST/PUT and throws "Invalid email" when the email
   * in the basic-details block does not match, so a draft cannot be stored on the
   * server until this passes. Drafts are kept in localStorage until it does.
   */
  private DRAFT_EMAIL_PATTERN =
    /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  public canSaveDraftRemotely(email: any): boolean {
    return (
      typeof email === "string" && this.DRAFT_EMAIL_PATTERN.test(email.trim())
    );
  }

  private static INSTANCE = new Utils();
}
export const utils = Utils.instance;
